// // import { createSlice } from "@reduxjs/toolkit";
// // import { Attendance } from "./store/reducers/Formapireducer";

// import { createSlice } from "@reduxjs/toolkit";
// import { getConfig } from "./config";

// let cfg = {};
// try {
//   cfg = getConfig(); // config.json already loaded in index.js
// } catch (e) {
//   cfg = {};
// }

// const apiurl = cfg.API_URL || "";
// const baseurl = cfg.BASE_URL || "";
// const baseurl1 = cfg.BOS_URL || "";

// // var apiurl ="https://ess.beyondexs.com/api/"
// // var baseurl = "https://ess.beyondexs.com/" 
// // var baseurl1 = "https://bos.beyondexs.com/"

// // var apiurl = "https://essuat.beyondexs.com/api/"
// // var baseurl = "https://essuat.beyondexs.com/"
// // var baseurl1 = "https://bosuat.beyondexs.com/"

// // var apiurl ="https://dvmtapi.bexatm.com/ess/api/"
// // var baseurl = "https://dvmtapi.bexatm.com/"
// //  var baseurl1 = "https://dvmtapi.bexatm.com/"
// // var apiurl = "https://phpmigrationapi.bexatm.com/ess/api/"
// // var baseurl ="https://phpmigrationapi.bexatm.com/"

// const initialState = {
//   baseUrl: baseurl,
//   baseUr1l: baseurl1,

//   attachmentUrl: baseurl1 + 'uploads/attachments/',
//   listViewurl: apiurl + 'wslistview_mysql.php',
//   loginUrl: apiurl + 'ESSLController.php',
//   comboUrl: apiurl + 'APIController.php',
//   apiUrl: apiurl + 'APIController.php',
//   imgUploadUrl: baseurl + 'imgup.php',
//   imageUrl: baseurl + "uploads/images/",
//   imageNameUpdateUrl: apiurl + 'CMController.php',
//   attachmentSkillUrl: baseurl + 'uploads/attachments/',
//   attachmentUrl: baseurl + 'uploads/attachments/',
//   custprodattachmentUrl: baseurl + 'uploads/custimage/',
//   fileUploadUrl: baseurl + 'fileupload.php',
//   csvUploadUrl: apiurl + 'csvupload.php',
//   pcdurl: apiurl + 'PCDController.php',
//   pdfurl: baseurl + 'tcpdf/',
//   indentUrl: apiurl + 'IndentController.php',
//   invoiceUrl: apiurl + 'InvoiceController.php',
//   commonUrl: apiurl + 'CommonController.php',
//   bomCopyUrl: apiurl + 'VersioningController.php',
//   bomHeaderUrl: apiurl + 'BOMController.php',
//   stockUrl: apiurl + 'StockController.php',
//   batchUrl: apiurl + 'BatchstructureController.php',
//   finalinvUrl: apiurl + 'FinalInvoiceController.php',
//   proformainvUrl: apiurl + 'ProfoinvoiceController.php',
//   orderUrl: apiurl + 'CustomerOrder.php',
//   stockReqUrl: apiurl + 'StockRequirement.php',
//   productUrl: apiurl + 'StockProcedure.php',
//   bomLkUrl: apiurl + 'InvoiceBomLkController.php',
//   designPUrl: apiurl + 'UomconversiongetController.php',
//   costingMatrialUrl: apiurl + 'BomcostController.php?',
//   conversionUrl: apiurl + 'UomconversiongetController.php',
//   userGroupUrl: apiurl + 'GroupaccessController.php',
//   dcTrackingUrl: apiurl + 'DctrackingController.php',
//   trackingUrl: apiurl + 'MaterialtrackingController.php',
//   supplierTrackUrl: apiurl + 'SuppliertrackingController.php',
//   materialsTrackingUrl: apiurl + 'MaterialTrackingChart.php',
//   supplytrackingUrl: apiurl + 'SupplierTrackingChart.php',
//   producttrackingUrl: apiurl + 'ProductpriceController.php?',
//   pIndentUrl: apiurl + 'PurchaseIndentController.php',
//   prdCardBthUrl: apiurl + 'PrdBatchIssueController.php',
//   customerorderanalysisUrl: apiurl + 'CustomerOrderChart.php?',
//   prductorderanalysisUrl: apiurl + 'ProductOrderChart.php?',
//   mailContentGeturl: apiurl + 'EmailController.php',
//   mailSendUrl: apiurl + 'invoicemail.php',
//   materialUomCovUrl: apiurl + 'MaterialUOMConversionController.php',
//   decryptUrl: apiurl + 'HashtokenController.php',
//   costingLeatherUrl: apiurl + 'BomLeathercost.php',
//   customerLeatherUrl: apiurl + 'CustomerLeatherController.php',
//   dcsummaryUrl: apiurl + 'getdcsummary.php',
//   dcpostsummaryUrl: apiurl + 'postdcsummary.php',
//   getempdeploymentUrl: apiurl + 'getempdeployment.php?',
//   postempdeployment: apiurl + 'postempdeployment.php?',
//   matProcurementUrl: apiurl + 'MaterialProcurementChart.php',
//   stockorderUrl: apiurl + 'MaterialOrderReportController.php',
//   getempcheckinUrl: apiurl + "getempcheckindetails.php",
//   salaryadvanceUrl: apiurl + "APIController.php",
//   leavelApprovalUrl: apiurl + "EmployeeRequestUpdateController.php",
//   apiweightageUrl: apiurl + 'HRWeightagesGetContoller.php',
//   weightagepostUrl: apiurl + 'HRWeightagesContoller.php',
//   SprintgetUrl: apiurl + "SprintHeaderandDetailController.php",
//   SprintPPGetUrl: apiurl + "SprintProjectPlanGetController.php",
//   requestAcknowledgeUrl: apiurl + "LeaveRequest.php",
//   mailNotificationUrl: apiurl + "ApprovalRejectionMail.php",
//   attendanceUrl: apiurl + "getempattendanceV2.php",
//   monthlyattendanceUrl: apiurl + "GetdatewiseEmpattendance.php",
//   getLeaveentryDataUrl: apiurl + "EmpLeaveConfigurationGetController.php",
//   payrollattendanceUrl: apiurl + "PayrollAttendanceController.php",
//   timesheetattendanceUrl: apiurl + "DailyTaskgetController.php",
//   timesheetreportattendanceUrl: apiurl + "Dailytask_getControllerV1.php",
//   PSRreportattendanceUrl: apiurl + "ProjectStatuaReportControllerV2.php",
//   timesheetdtUrl: apiurl + "DailyTaskpostController.php",
//   forgotUrl: apiurl + 'ForgetPasswordController.php',
//   ChangepasswordUrl: apiurl + 'EssChangePasswordController.php',
//   regGetUrl: apiurl + 'RegularizationGetController.php',
//   spotActGetUrl: apiurl + "spotactivityGet.php",
//   dashBoardTaskUrl: apiurl + "Ess_DashboardTaskSummaryController.php",
//   dashBoardAttendanceUrl: apiurl + "Ess_DashboardAttendanceOverviewController.php",
//   CalUrl: apiurl + "ESSDashboardCurrentYeasterBackclockController.php",
//   empAttachmentUrl: baseurl + "EmployeeAttachmentsController.php",
//   empGetAttachmentUrl: apiurl + "getAttachmentsController.php",
//   dashcalUrl: apiurl + "CalendarController.php",
//   projectRoleurl: apiurl + "ProjectTeamsGetController.php",
//   dashBoardV1url: apiurl + "DashboardControllerV2.php",
//   Scoreboard: apiurl + "ScoreBoardChartController.php",
//   // dashBoardV1url:"http://localhost/server/cafemgr/api/DashboardController.php",
//   dashBoardV1urlEmployeeEffort: apiurl + "ProjectemployeeController.php",
//   approvallisturl: apiurl + "ApprovalListsController.php",
//   movementsUrl: apiurl + "EmployeeMomentsGetController.php",
//   treeUrl: apiurl + "TreeController.php",
//   scrumupdateUrl: apiurl + "DailytaskUpdatePostControllerV1.php",
//   scrumupdateGetUrl: apiurl + "DailytaskUpdateGetController.php",
//   AttendanceentryrGetUrl: apiurl + "AttendanceEntryGetControllerV1.php",
//   AttendanceentryrPostUrl: apiurl + "AttendanceEntryPostControllerV2.php",
//   ProjEnquiryUrl: apiurl + "ProjectEnquiryController.php",
//   SprintBurnDownUrl: apiurl + "DashboardSprintBurndownControllerBeta4.php",
//   ApprovalVerifyUrl: apiurl + "DailyTaskpostVerifyController.php",
//   PermissionApprovalVerifyUrl: apiurl + "PermisionApproval.php",
//   filterPostUrl: apiurl + "DefaultFilterInsertController.php",
//   filterGetUrl: apiurl + "DefaultFilterGetController.php",
//   SessionCheckUrl: apiurl + "ScheduleSessionDateUpdate.php",
//   AnswerGetUrl: apiurl + "AnswerGetController.php",
//   AssessmentCheckUrl: apiurl + "EmployeeAssignmentCheckController.php",
//   AIvoiceassistanturl: apiurl + "AI/task-php/public/index.php",
//   AppraisalGetController: apiurl + "EssAssessmentGetContoller.php",
//   AppraisalScoreBoardController: apiurl + "AppraisalScoreBoardContoller.php",
//   Invoicegenerate: apiurl + "InvoicePDFM5.php",
//   SprintInvoicegenerate: apiurl + "SprintTaskInvoicePdfPost.php",
//   //SprintInvoicegenerate: apiurl + "SprintTaskInvoicePdfPostM5.php",
//   SprintInvoiceGet: apiurl + "SprintTaskInvoicePdfGet.php"
// };

// export const getUrlSlice = createSlice({
//   name: "globalurl",
//   initialState,
//   reducers: {},
// });

// export default getUrlSlice.reducer;



import { createSlice } from "@reduxjs/toolkit";
import { getConfig } from "./config";

const initialState = {
  baseUrl: "",
  baseUrl1: "",

  attachmentUrl: "",
  videoattachmentUrl: "",
  audioattachmentUrl: "",
  listViewurl: "",
  loginUrl: "",
  comboUrl: "",
  apiUrl: "",
  imgUploadUrl: "",
  imageUrl: "",
  EventsimageUrl: "",
  imageNameUpdateUrl: "",
  attachmentSkillUrl: "",
  custprodattachmentUrl: "",
  fileUploadUrl: "",
  csvUploadUrl: "",
  pcdurl: "",
  pdfurl: "",
  indentUrl: "",
  invoiceUrl: "",
  commonUrl: "",
  bomCopyUrl: "",
  bomHeaderUrl: "",
  stockUrl: "",
  batchUrl: "",
  finalinvUrl: "",
  proformainvUrl: "",
  orderUrl: "",
  stockReqUrl: "",
  productUrl: "",
  bomLkUrl: "",
  designPUrl: "",
  costingMatrialUrl: "",
  conversionUrl: "",
  userGroupUrl: "",
  dcTrackingUrl: "",
  trackingUrl: "",
  supplierTrackUrl: "",
  materialsTrackingUrl: "",
  supplytrackingUrl: "",
  producttrackingUrl: "",
  pIndentUrl: "",
  prdCardBthUrl: "",
  customerorderanalysisUrl: "",
  prductorderanalysisUrl: "",
  mailContentGeturl: "",
  mailSendUrl: "",
  materialUomCovUrl: "",
  decryptUrl: "",
  costingLeatherUrl: "",
  customerLeatherUrl: "",
  dcsummaryUrl: "",
  dcpostsummaryUrl: "",
  getempdeploymentUrl: "",
  postempdeployment: "",
  getResignationUrl: "",
  postResignation: "",
  matProcurementUrl: "",
  stockorderUrl: "",
  getempcheckinUrl: "",
  salaryadvanceUrl: "",
  leavelApprovalUrl: "",
  apiweightageUrl: "",
  weightagepostUrl: "",
  SprintgetUrl: "",
  SprintPPGetUrl: "",
  requestAcknowledgeUrl: "",
  mailNotificationUrl: "",
  attendanceUrl: "",
  monthlyattendanceUrl: "",
  getLeaveentryDataUrl: "",
  payrollattendanceUrl: "",
  timesheetattendanceUrl: "",
  timesheetreportattendanceUrl: "",
  PSRreportattendanceUrl: "",
  timesheetdtUrl: "",
  forgotUrl: "",
  ChangepasswordUrl: "",
  regGetUrl: "",
  spotActGetUrl: "",
  dashBoardTaskUrl: "",
  dashBoardAttendanceUrl: "",
  Dashboard_V2: "",
  CalUrl: "",
  empAttachmentUrl: "",
  empGetAttachmentUrl: "",
  dashcalUrl: "",
  EventCalendarGet: "",
  projectRoleurl: "",
  dashBoardV1url: "",
  Scoreboard: "",
  dashBoardV1urlEmployeeEffort: "",
  approvallisturl: "",
  movementsUrl: "",
  treeUrl: "",
  scrumupdateUrl: "",
  scrumupdateGetUrl: "",
  AttendanceentryrGetUrl: "",
  AttendanceentryrPostUrl: "",
  ProjEnquiryUrl: "",
  SprintBurnDownUrl: "",
  ApprovalVerifyUrl: "",
  PermissionApprovalVerifyUrl: "",
  filterPostUrl: "",
  filterGetUrl: "",
  SessionCheckUrl: "",
  AnswerGetUrl: "",
  AssessmentCheckUrl: "",
  AIvoiceassistanturl: "",
  AppraisalGetController: "",
  AppraisalScoreBoardController: "",
  Invoicegenerate: "",
  SprintInvoicegenerate: "",
  SprintInvoiceGet: "",
  CheckEmpcontractwithFlag: "",
  Invoicegetempattendance: "",
  ProjectStatusReport: "",
  ProjectStatusReportBarChart: "",
  measuregeturl: "",
  MeasureUpdate: "",
  WeeklycaledarUrl: "",
  WeeklyTeachercaledarUrl: "",
  StudentTTgetUrl: "",
  HomeworkGetUrl: "",
  HomeworkPOSTUrl: "",
  HomeworkEvalGetUrl: "",
  HomeworkEvalPOSTUrl: "",
  HomeworkAnalticsGetUrl: "",
  AssessmentVerifyGet:"",
  AssessmentVerifyUpdateController:"",
  RepaymentScheduleGet: "",
  RepaymentSchedulePost: "",
  RepaymentHDgetController: "",
  AssessmentEvaluateController: "",
  ProductCosting: "",
  CostOverview: "",
  CostTrend: "",
  EmployeeOverrun: "",
  ProjectManagerDashboard: "",
  DashboardVisualLeaveApproval: "",
  TimetableProcessController: "",
  InvoiceAnalytics:"",
  EmergencyNotificationGet:"",
  EmergencyNotificationPost:"",
  TeacherOccupancy:"",
  PayslipGetController: "",
  TeacherGetUrl: "",
  timetableGetUrl: "",
  TeacherinvoiceGetUrl: "",
  EmployeeSprintOccupancy:"",
TotalHrsOccupiedHrsGet: "",
DesignationGet: "",
ProjectSplitupHrsList: "",
EmployeeMapController: "",
ProjectTeamsMembersGet: ""
};

export const getUrlSlice = createSlice({
  name: "globalurl",
  initialState,
  reducers: {
    initGlobalUrl: (state) => {
      const config = getConfig();

      const apiurl = config.API_URL;
      const baseurl = config.BASE_URL;
      const baseurl1 = config.BOS_URL;

      state.baseUrl = baseurl;
      state.baseUrl1 = baseurl1;
      state.attachmentUrl = baseurl1 + "uploads/attachments/";
      state.videoattachmentUrl = baseurl1 + "uploads/videos/";
      state.audioattachmentUrl = baseurl1 + "uploads/audios/";
      state.listViewurl = apiurl + "wslistview_mysql.php";
      // state.listViewurl = apiurl + "wslistview_mysqlV1.php";
      state.loginUrl = apiurl + "ESSLController.php";
      state.comboUrl = apiurl + "APIController.php";
      state.apiUrl = apiurl + "APIController.php";
      state.imgUploadUrl = baseurl + "imgup.php";
      state.imageUrl = baseurl + "uploads/images/";
      state.EventsimageUrl = baseurl1 + "uploads/images/";
      state.imageNameUpdateUrl = apiurl + "CMController.php";
      state.attachmentSkillUrl = baseurl + "uploads/attachments/";
      state.custprodattachmentUrl = baseurl + "uploads/custimage/";
      state.fileUploadUrl = baseurl + "fileupload.php";
      state.csvUploadUrl = apiurl + "csvupload.php";
      state.pcdurl = apiurl + "PCDController.php";
      state.pdfurl = baseurl + "tcpdf/";
      state.indentUrl = apiurl + "IndentController.php";
      state.invoiceUrl = apiurl + "InvoiceController.php";
      state.commonUrl = apiurl + "CommonController.php";
      state.bomCopyUrl = apiurl + "VersioningController.php";
      state.bomHeaderUrl = apiurl + "BOMController.php";
      state.stockUrl = apiurl + "StockController.php";
      state.batchUrl = apiurl + "BatchstructureController.php";
      state.finalinvUrl = apiurl + "FinalInvoiceController.php";
      state.proformainvUrl = apiurl + "ProfoinvoiceController.php";
      state.orderUrl = apiurl + "CustomerOrder.php";
      state.stockReqUrl = apiurl + "StockRequirement.php";
      state.productUrl = apiurl + "StockProcedure.php";
      state.bomLkUrl = apiurl + "InvoiceBomLkController.php";
      state.designPUrl = apiurl + "UomconversiongetController.php";
      state.costingMatrialUrl = apiurl + "BomcostController.php?";
      state.conversionUrl = apiurl + "UomconversiongetController.php";
      state.userGroupUrl = apiurl + "GroupaccessController.php";
      state.dcTrackingUrl = apiurl + "DctrackingController.php";
      state.trackingUrl = apiurl + "MaterialtrackingController.php";
      state.supplierTrackUrl = apiurl + "SuppliertrackingController.php";
      state.materialsTrackingUrl = apiurl + "MaterialTrackingChart.php";
      state.supplytrackingUrl = apiurl + "SupplierTrackingChart.php";
      state.producttrackingUrl = apiurl + "ProductpriceController.php?";
      state.pIndentUrl = apiurl + "PurchaseIndentController.php";
      state.prdCardBthUrl = apiurl + "PrdBatchIssueController.php";
      state.customerorderanalysisUrl = apiurl + "CustomerOrderChart.php?";
      state.prductorderanalysisUrl = apiurl + "ProductOrderChart.php?";
      state.mailContentGeturl = apiurl + "EmailController.php";
      state.mailSendUrl = apiurl + "invoicemail.php";
      state.materialUomCovUrl = apiurl + "MaterialUOMConversionController.php";
      state.decryptUrl = apiurl + "HashtokenController.php";
      state.costingLeatherUrl = apiurl + "BomLeathercost.php";
      state.customerLeatherUrl = apiurl + "CustomerLeatherController.php";
      state.dcsummaryUrl = apiurl + "getdcsummary.php";
      state.dcpostsummaryUrl = apiurl + "postdcsummary.php";
      state.getempdeploymentUrl = apiurl + "getempdeployment.php?";
      state.postempdeployment = apiurl + "postempdeployment.php?";
       state.getResignationUrl = apiurl + "ResignationGet.php";
      state.postResignation = apiurl + "ResignationPost.php";
      state.matProcurementUrl = apiurl + "MaterialProcurementChart.php";
      state.stockorderUrl = apiurl + "MaterialOrderReportController.php";
      state.getempcheckinUrl = apiurl + "getempcheckindetails.php";
      state.salaryadvanceUrl = apiurl + "APIController.php";
      state.leavelApprovalUrl = apiurl + "EmployeeRequestUpdateController.php";
      state.apiweightageUrl = apiurl + "HRWeightagesGetContoller.php";
      state.weightagepostUrl = apiurl + "HRWeightagesContoller.php";
      state.SprintgetUrl = apiurl + "SprintHeaderandDetailController.php";
      state.SprintPPGetUrl = apiurl + "SprintProjectPlanGetController.php";
      state.requestAcknowledgeUrl = apiurl + "LeaveRequest.php";
      state.mailNotificationUrl = apiurl + "ApprovalRejectionMail.php";
      state.attendanceUrl = apiurl + "getempattendance.php";
      state.monthlyattendanceUrl = apiurl + "GetdatewiseEmpattendance.php";
      state.getLeaveentryDataUrl = apiurl + "EmpLeaveConfigurationGetController.php";
      state.payrollattendanceUrl = apiurl + "PayrollAttendanceController.php";
      state.timesheetattendanceUrl = apiurl + "DailyTaskgetController.php";
      state.timesheetreportattendanceUrl = apiurl + "Dailytask_getControllerV1.php";
      state.PSRreportattendanceUrl = apiurl + "ProjectStatuaReportControllerV2.php";
      state.timesheetdtUrl = apiurl + "DailyTaskpostController.php";
      state.forgotUrl = apiurl + "ForgetPasswordController.php";
      state.ChangepasswordUrl = apiurl + "EssChangePasswordController.php";
      state.regGetUrl = apiurl + "RegularizationGetController.php";
      state.spotActGetUrl = apiurl + "spotactivityGet.php";
      state.dashBoardTaskUrl = apiurl + "Ess_DashboardTaskSummaryController.php";
      state.dashBoardAttendanceUrl = apiurl + "Ess_DashboardAttendanceOverviewController.php";
      state.Dashboard_V2 = apiurl + "DashboardVisual.php";
      state.CalUrl = apiurl + "ESSDashboardCurrentYeasterBackclockController.php";
      state.empAttachmentUrl = baseurl + "EmployeeAttachmentsController.php";
      state.empGetAttachmentUrl = apiurl + "getAttachmentsController.php";
      state.dashcalUrl = apiurl + "CalendarControllerV9.php";
      state.EventCalendarGet = apiurl + "EventCalendarGet.php";
      state.projectRoleurl = apiurl + "ProjectTeamsGetController.php";
      state.dashBoardV1url = apiurl + "DashboardControllerV2.php";
      state.Scoreboard = apiurl + "ScoreBoardChartController.php";
      state.dashBoardV1urlEmployeeEffort = apiurl + "ProjectemployeeController.php";
      state.approvallisturl = apiurl + "ApprovalListsController.php";
      state.movementsUrl = apiurl + "EmployeeMomentsGetController.php";
      state.treeUrl = apiurl + "TreeController.php";
      state.scrumupdateUrl = apiurl + "DailytaskUpdatePostControllerV1.php";
      state.scrumupdateGetUrl = apiurl + "DailytaskUpdateGetController.php";
      state.AttendanceentryrGetUrl = apiurl + "AttendanceEntryGetControllerV1.php";
      state.AttendanceentryrPostUrl = apiurl + "AttendanceEntryPostControllerV3.php";
      state.ProjEnquiryUrl = apiurl + "ProjectEnquiryController.php";
      state.SprintBurnDownUrl = apiurl + "DashboardSprintBurndownControllerBeta4.php";
      state.ApprovalVerifyUrl = apiurl + "DailyTaskpostVerifyController.php";
      state.PermissionApprovalVerifyUrl = apiurl + "PermisionApproval.php";
      state.filterPostUrl = apiurl + "DefaultFilterInsertController.php";
      state.filterGetUrl = apiurl + "DefaultFilterGetController.php";
      state.SessionCheckUrl = apiurl + "ScheduleSessionDateUpdate.php";
      state.AnswerGetUrl = apiurl + "AnswerGetController.php";
      state.AssessmentCheckUrl = apiurl + "EmployeeAssignmentCheckController.php";
      state.AIvoiceassistanturl = apiurl + "AI/task-php/public/index.php";
      state.AppraisalGetController = apiurl + "EssAssessmentGetContoller.php";
      state.AppraisalScoreBoardController = apiurl + "AppraisalScoreBoardContoller.php";
      state.Invoicegenerate = apiurl + "InvoicePDFM7.php";
      state.SprintInvoicegenerate = apiurl + "SprintTaskInvoicePdfPost.php";
      state.SprintInvoiceGet = apiurl + "SprintTaskInvoicePdfGet.php";
      state.UserActivityUrl = apiurl + "UserActivityController.php";
      state.CheckEmpcontractwithFlag = apiurl + "CheckEmpcontractwithFlag.php";
      state.Invoicegetempattendance = apiurl + "Invoicegetempattendance.php";
      state.ProjectStatusReport = apiurl + "ProjectStatusReport.php";
      state.ProjectStatusReportBarChart = apiurl + "ProjectWishStatusReport.php";
      state.measuregeturl = apiurl + "FinanceentryspotactivityGet.php";
      state.MeasureUpdate = apiurl + "FinanceEntrySpotActivityUpdate.php";
      state.AssessmentVerifyGet = apiurl + "AssessmentVerifyGet.php";
      state.AssessmentVerifyUpdateController = apiurl + "AssessmentVerifyUpdateController.php";
      state.WeeklycaledarUrl = apiurl + "WeeklyClassCalendarGet.php";
      state.WeeklyTeachercaledarUrl = apiurl + "TeacherScheduleGetController.php";
      state.StudentTTgetUrl = apiurl + "StudentTimetable.php";
      state.HomeworkGetUrl = apiurl + "StudentGetController.php";
      state.HomeworkPOSTUrl = apiurl + "HomeworkPostController.php";
      state.HomeworkEvalGetUrl = apiurl + "HomeworkEvalGetController.php";
      state.HomeworkEvalPOSTUrl = apiurl + "HomeworkEvalPostController.php";
      state.HomeworkAnalticsGetUrl = apiurl + "EvaluationChartFile.php";
      state.RepaymentScheduleGet = apiurl + "RepaymentScheduleGet.php";
      state.RepaymentSchedulePost = apiurl + "RepaymentSchedulePost.php";
      state.RepaymentHDgetController = apiurl + "RepaymentHDgetController.php";
      state.AssessmentEvaluateController = apiurl + "AssessmentEvaluateController.php";
      state.ProductCosting = apiurl + "ProductCosting.php";
      state.CostOverview = apiurl + "CostOverview.php";
      state.CostTrend = apiurl + "CostTrend.php";
      state.EmployeeOverrun = apiurl + "getEmployeeOverrun.php";
      state.ProjectManagerDashboard = apiurl + "DashboardVisual.php";
      state.DashboardVisualLeaveApproval = apiurl + "DashboardVisualLeaveApprovals.php";
      state.TimetableProcessController = apiurl + "TimetableProcessController.php";
      state.InvoiceAnalytics = apiurl + "InvoiceAnalytics.php";
      state.EmergencyNotificationGet = apiurl + "EmergencyNotificationGet.php";
      state.EmergencyNotificationPost = apiurl + "EmergencyNotificationPost.php";
      state.TeacherOccupancy = apiurl + "TeacherOccupancy.php";
      state.PayslipGetController = apiurl + "PayslipGetController.php";
      state.TeacherGetUrl = apiurl + "SubjectTeacherGetController.php";
      state.timetableGetUrl = apiurl + "StudentTimetable.php";
      state.TeacherinvoiceGetUrl = apiurl + "TeacherInvoiceGetController.php";
      state.EmployeeSprintOccupancy = apiurl + "EmployeeSprintOccupancy.php";
      state.TotalHrsOccupiedHrsGet = apiurl + "TotalHrsOccupiedHrsGet.php";
      state.DesignationGet = apiurl + "ProjectWiseRoleList.php";
      state.ProjectSplitupHrsList = apiurl + "ProjectSplitupHrsList.php";
      state.EmployeeMapController = apiurl + "EmployeeMapController.php";
      state.ProjectTeamsMembersGet = apiurl + "ProjectTeamsMembersGet.php";
    },
  },
});

export const { initGlobalUrl } = getUrlSlice.actions;
export default getUrlSlice.reducer;


